const defaultLevelHp = {
  level1: 1000,
  level2: 1100,
  level3: 1200,
  level4: 1300,
  level5: 1400,
  level6: 1500,
  level7: 1600,
  level8: 1700,
  level9: 1800,
  level10: 2000,
};

export const BUILDING_DEFAULT_HP = {
  tower: { ...defaultLevelHp },
  well_1: { ...defaultLevelHp },
  well_2: { ...defaultLevelHp },
  wall: { ...defaultLevelHp },
  support: { ...defaultLevelHp },
  hunting: { ...defaultLevelHp },
  bank: { ...defaultLevelHp },
  training: { ...defaultLevelHp },
  hospital: { ...defaultLevelHp },
  wheatFarm: { ...defaultLevelHp },
  bakery: { ...defaultLevelHp },
  bakery_2: { ...defaultLevelHp },
  woodHouse: { ...defaultLevelHp },
  stoneFactory: { ...defaultLevelHp },
  ironMine: { ...defaultLevelHp },
  ironMine_2: { ...defaultLevelHp },
  blacksmith: { ...defaultLevelHp },
  kingdom: {
    level1: 1000,
    level2: 1200,
    level3: 1400,
    level4: 1600,
    level5: 1800,
    level6: 2000,
  },
};
